// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import styles from "./progressRing.module.scss";

const SIZE = 64;
const STROKE_WIDTH = 6;
const RADIUS = (SIZE - STROKE_WIDTH) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

function ProgressRing({ percent, label }) {
    const clamped = Math.max(0, Math.min(100, percent));
    const offset = CIRCUMFERENCE - (clamped / 100) * CIRCUMFERENCE;

    return (
        <div
            className={styles.ring}
            role="progressbar"
            aria-label={label}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow={clamped}
        >
            <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
                <circle
                    className={styles.track}
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeWidth={STROKE_WIDTH}
                    fill="none"
                />
                <circle
                    className={styles.fill}
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeWidth={STROKE_WIDTH}
                    fill="none"
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={offset}
                    transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
                />
            </svg>
            <span className={styles.label}>{clamped}%</span>
        </div>
    );
}

export default ProgressRing;
